export const SET_INVOICE_HTML = "SET_INVOICE_HTML";
export const SET_INVOICE_DATE = "SET_INVOICE_DATE";
export const SET_DELIVERY_DATE = "SET_DELIVERY_DATE";
export const SET_RECURRING_START_DATE = "SET_RECURRING_START_DATE";
export const SET_RECURRING_FREQUENCY = "SET_RECURRING_FREQUENCY";
